module.exports = __webpack_public_path__ + "img/logbook-white.svg";